import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNAgendaAppointment } from './snagendaappointment';
import { SNUser } from './snuser';

@RegisterItem()
export class SNAgenda extends SNUser {

    public appointments: SNAgendaAppointment[];

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNAgenda';
    }

    /**
     * JSON
     */

    public fromJson(json: any, emitLoaded?: boolean): void {
        super.fromJson(json, emitLoaded);
        if (typeof json.appointments !== 'undefined' && Array.isArray(json.appointments) && json.appointments.length !== 0) {
            // appointments
            this.appointments = [];
            json.appointments.forEach(jsonAppointment => {
                const appointment = new SNAgendaAppointment();
                appointment.fromJson(jsonAppointment);
                this.appointments.push(appointment);
            });
        }
    }

    public clone(): any {
        return new SNAgenda();
    }
}
